import React from 'react';

import Thumb from '../img/doctors-portal.png';
import Img from '../img/doctors-portal2.png';

const DoctorsPortal = {
    id: 102, permalink: "doctors-portal", thumb: Thumb, title: "Doctors Portal", category: "React", categoryURL: "react", detailImg1: Thumb, detailImg2: Img, previewTxt: "Preview", previewURL: "https://w-doctors-portal.web.app/", sourceTxt: "", sourceURL: "", description: <>
        <h3>Doctors Portal is a Doctors web app.</h3>
        <p>&nbsp;</p>

        <h5>Main Featured:</h5>
        <ul>
            <li>Data load from live database</li>
            <li>Book Appointment for Patients</li>
            <li>Doctors Dashboard to see all Patients, Appointments etc.</li>
            <li>Update-able Appointments</li>
        </ul>

        <h5>Technology Used:</h5>
        <ul>
            <li>React, Node, Firebase, Heroku, MongoDB.</li>
        </ul>
    </>
};
export default DoctorsPortal;